import { h } from "preact";
import register from "preact-custom-element";
import useProduct from "../../helpers/useProduct/useProduct";
import { Ruler } from "../../helpers/icons";
import SizeGuideTrigger from "./size-guide-trigger";

function SizeGuideLink({ productId }) {
  const [product] = useProduct(productId);

  if (!product?.sizeGuide) return null;

  return (
    <SizeGuideTrigger sizeGuide={product.sizeGuide} className="size-guide-link">
      <Ruler />
      <span className="size-guide-link__text link link--x-small">
        {window.localeStrings.product.size_guide}
      </span>
    </SizeGuideTrigger>
  );
}

if (!customElements.get("size-guide-link")) {
  register(SizeGuideLink, "size-guide-link", ["product-id"], {
    shadow: false,
  });
}
